import { Box, Paper, Typography } from "@mui/material";
import PublicationItem from "./Publication";
import { useTranslation } from "react-i18next";
import { OtherPubs } from "./OtherPubs";

const publications = [
  {
    title:
      "Gekonnt handeln – Prävention für Beschäftigte in haushaltsnahen Dienstleistungen",
    authors:
      "Geiger, L., Faller, G., Grimm, V., Rubart, J., Weber, M., & Vennebusch, T.",
    journal: "Betriebliche Prävention, 9-2022",
    date: 2022,
    summary:
      "Beschäftigte in haushaltsnahen Dienstleistungen wurden bislang gesellschaftlich wenig beachtet und wissenschaftlich kaum untersucht. Der Beitrag zeigt, weshalb und wie im Rahmen eines Forschungsprojektes der Fokus auf diese Gruppe gelegt wird, von welchen Rahmenbedingungen die Beschäftigung in haushaltsnahen Dienstleistungen gekennzeichnet ist und welche Erkenntnisse im Projekt bereits zu Arbeitsbedingungen, Belastungen und Ressourcen der Beschäftigten gewonnen werden konnten.",
    fullTextUrl:
      "https://beprdigital.de/ce/gekonnt-handeln-praevention-fuer-beschaeftigte-in-haushaltsnahen-dienstleistungen/detail.html",
    doiUrl: "https://doi.org/10.37307/j.2365-7634.2022.09.08",
    accessible: true,
  },
  {
    title:
      "Partizipativer Entwicklungsprozess einer Trainingsplattform für Haushaltshilfen",
    authors: "Grimm, Valentin; Rubart, Jessica; Faller, Gudrun; Geiger, Laura",
    journal: "Mensch und Computer 2023 - Workshopband",
    date: 2023,
    summary:
      "Die Gruppe der Angestellten in haushaltsnahen Dienstleistungen wurde bisher in Forschung und Praxis wenig beachtet. Daher wird diese spezielle Zielgruppe in unserem Forschungsprojekt in den Fokus gestellt und partizipativ eine Trainingsplattform entwickelt. Diese soll der Zielgruppe relevante Hilfestellungen für ihren Arbeitsalltag an die Hand geben. Im Zuge dessen stellen wir in diesem Papier den Gekonnt handeln partizipativen Prozess zur Entwicklung der Plattform vor. Dieser zeichnet sich durch den Umgang mit einer bisher in Forschung und Praxis wenig fokussierten Zielgruppe im Schnittstellenbereich Arbeit, Gesundheit und Diversity aus. Des Weiteren kennzeichnet sich der Prozess durch einen multimethodischen Ansatz, welcher qualitative und quantitative Methoden der Datenerhebung mit partizipativ entwickelten und evaluierten Edutainment-Angeboten kombiniert.",
    fullTextUrl: "https://dl.gi.de/items/29974ca0-13d5-472f-98a7-c602acf2f4ac",
    doiUrl: "https://doi.org/10.18420/muc2023-mci-ws02-258",
    accessible: true,
  },
  {
    title:
      "Gekonnt hanDeln – Arbeitsbedingungen, Belastungen und Ressourcen bei privat beschäftigten Haushaltshilfen ",
    authors: "Geiger, Laura; Faller, Gudrun",
    journal: "6. Community Health Konferenz",
    date: 2024,
    summary:
      "In Deutschland sind rund 300.000 Personen legal im Bereich haushaltsnaher Dienstleistungen beschäftigt, während etwa 3 Millionen Menschen unangemeldet in Privathaushalten arbeiten. Diese meist weiblichen, älteren Beschäftigten mit Migrationshintergrund sind sozial schlechter abgesichert als gewerblich Beschäftigte. Arbeits- und Gesundheitsschutz sind problematisch, und die Beschäftigten sind gesundheitlich vulnerabel. Das Projekt „Gekonnt hanDeln“ an der HS Gesundheit untersucht diese Bedingungen und soll das Bewusstsein und Wissen über die Arbeitsbedingungen verbessern. Ein Kurzvortrag stellt das Projekt und Erkenntnisse aus Studien zu Arbeitsbedingungen und Belastungen vor.",
    fullTextUrl: "https://www.egms.de/static/en/meetings/chk2023/23chk34.shtml",
    doiUrl: "https://dx.doi.org/10.3205/23chk34",
    accessible: true,
  },
  {
    title:
      "Menschengerechte Gestaltung der Arbeit in Privathaushalten – das Projekt „Gekonnt hanDeln“",
    authors: "Geiger, Laura; Faller, Gudrun",
    journal:
      "Conference: Menschengerechte Arbeitsgestaltung – Basisarbeit und neue Arbeitsformen. ",
    date: 2023,
    summary: "",
    fullTextUrl:
      "https://www.researchgate.net/publication/375423057_Menschengerechte_Gestaltung_der_Arbeit_in_Privathaushalten_-_das_Projekt_Gekonnt_hanDeln",
    doiUrl: null,
    accessible: false,
  },
  {
    title:
      "Gekonnt hanDeln – Gesund und kompetent in haushaltsnahen Dienstleistungen",
    authors: "Geiger, Laura",
    journal: "Conference: Public Health3 2023",
    date: 2023,
    summary: "",
    fullTextUrl:
      "https://www.researchgate.net/publication/368477866_Gekonnt_hanDeln_-_Gesund_und_kompetent_in_haushaltsnahen_Dienstleistungen",
    doiUrl: null,
    accessible: false,
  },
  {
    title:
      "Beschäftigung in Privathaushalten unter den Bedingungen der Covid-19-Pandemie",
    authors: "Geiger, Laura; Faller, Gudrun",
    journal: "5. Community Health Konferenz. Bochum",
    date: 2022,
    summary: "",
    fullTextUrl:
      "https://www.researchgate.net/publication/368477996_Beschaftigung_in_Privathaushalten_unter_den_Bedingungen_der_Covid-19-Pandemie_5_Community_Health_Konferenz_Bochum_24-25112022_Dusseldorf_German_Medical_Science_GMS_Publishing_House_2022",
    doiUrl: "http://dx.doi.org/10.3205/22chk60",
    accessible: false,
  },
  {
    title:
      "Mittendrin und doch außen vor: Beschäftigte in haushaltsnahen Dienstleistungen",
    authors: "Geiger, Laura; Faller, Gudrun",
    journal:
      "Conference: 22. Workshop: Psychologie der Arbeitssicherheit und Gesundheit",
    date: 2022,
    summary: "",
    fullTextUrl:
      "https://www.researchgate.net/publication/368478222_Mittendrin_und_doch_aussen_vor_Beschaftigte_in_haushaltsnahen_Dienstleistungen",
    doiUrl: null,
    accessible: false,
  },
  {
    title: "Unlocking E-learning and XAI Concepts with Free Limited Choice",
    authors: "Grimm, Valentin; Rubart, Jessica",
    journal: "Mensch und Computer 2023 - Workshopband",
    date: 2023,
    summary:
      'This paper focuses on a game design element that aims to increase the motivation of users to focus on a single aspect while having a strong feeling of free choice. We call this concept "Free Limited Choice"(FLC). To approach this idea, we present two scenarios in different domains-e-learning and eXplainable AI (XAI). XAI in particular, is a quite new field for applying gamification concepts. In first preliminary user studies, we collect data for a first assessment of each scenario and specifically FLC. Based on this data, we conclude that FLC can be a useful concept for the desired purpose, but also highlight different aspects to consider when utilizing it.',
    fullTextUrl: "https://dl.gi.de/items/876b0326-9864-4cb5-871c-113f67671402",
    doiUrl: "https://doi.org/10.18420/muc2023-mci-ws08-354",
    accessible: true,
  },
  {
    title:
      "Modelling Gamified Systems with Event Storming Augmented by Spatial Hypertext",
    authors: "Grimm, Valentin; Rubart, Jessica",
    journal:
      "HUMAN '21: Proceedings of the 4th Workshop on Human Factors in Hypertext",
    date: 2021,
    summary:
      "Gamification is a widely used way of increasing motivation and fun in the use of systems that are not games. By outlining critical aspects in developing gamified systems, we adapted the modelling technique event storming in the context of a special case study where a gamified, collaborative platform was developed. For this purpose, the relationship of event storming and spatial hypertext has been worked out and an event storming extension has been introduced based on spatial hypertext principles. With respect to the case study and further insights in the academic context, we discuss how the emerging nature of event storming could benefit from a specialized spatial hypertext tool.",
    fullTextUrl:
      "https://dl.acm.org/doi/abs/10.1145/3468143.3483927?casa_token=-Gvrgl6_p2MAAAAA:yypmMlTYfjMneG0LquvlRr3NjcsD2RjjWEKMs_jzsbxz9nJUmca5J_NMSxEiSeYPKFGJVjmiIxCRhw",
    doiUrl: "https://doi.org/10.1145/3468143.3483927",
    accessible: true,
  },
  {
    title: "A Gamification Design Tool to Improve Design Quality",
    authors: "Grimm, Valentin",
    journal: "MuC '22: Proceedings of Mensch und Computer 2022",
    date: 2022,
    summary:
      "This demo features a prototype of a software tool to guide developers through the process of gamification design. It shall improve gameful designs, especially in the scientific community, and make the process of gamification design more accessible for non-experts in the field. The main goal of this first version is to gain user feedback on its usefulness with respect to intuition of use, its documentation capabilities and collaboration.",
    fullTextUrl:
      "https://dl.acm.org/doi/abs/10.1145/3543758.3547510?casa_token=FUvXAL3BsPMAAAAA:5iIFZ1B4TdHeh8M-QOldWRFwt4C1elmrE7Mya2E_aIIo5RBsN6lyA7VuyIfa9f1TKRYokDmI3rc6RQ",
    doiUrl: "https://doi.org/10.1145/3543758.354751",
    accessible: true,
  },
];

publications.sort((a, b) => (a.date < b.date ? 1 : -1));

const otherPubs = [
  {
    title: "Geschlechtsbedingte und soziale Ungleichheit von Beschäftigte in Privathaushalten: Bestandsaufnahme zu einem vernachlässigten Community Health-Thema",
    type: "Community Health Konferenz",
    authors: "Gudrun Faller",
    date: "29. November 2019",
    fullTextUrl: ""
  },
  {
    title: "Psychosoziale Belastungen und Ressourcen privat beschäftigter Haushaltshilfen",
    type: "Onlinetagung des Public Health Zentrum Fulda (PHZF)",
    authors: "Laura Geiger",
    date: "2020",
    fullTextUrl: ""
  },
  {
    title: "Psychosoziale Belastungen und Ressourcen privat beschäftigter Haushaltshilfen",
    type: "Onlinetagung des Public Health Zentrum Fulda (PHZF)",
    authors: "Laura Geiger",
    date: "2020",
    fullTextUrl: ""
  }
]

export default function Publications() {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography variant="h2" sx={{ mt: 3 }}>
        {t("navigationCat12")}
      </Typography>
      {publications.map((v) => {
        return <PublicationItem key={v.title} publication={v} />;
      })}
      {/* <Typography variant="h3" sx={{ my: 2 }} align="left">
        Weiteres
      </Typography>
      {otherPubs.map((v) => {
        return <OtherPubs key={v.title} publication={v} />;
      })} */}
    </Box>
  );
}
